<template>
  <div class="tender-list-container">
    <h1 class="page-title">
      {{ $t('message.header.tenderList') }}
    </h1>
    <!-- 表格部分：添加加载状态 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        backgroundColor: '#f2f2f2',
        color: '#333',
        fontSize: '14px',
      }"
      :cell-style="{ fontSize: '14px' }"
      v-loading="loading"
      element-loading-text="Loading data..."
    >
      <el-table-column
        type="index"
        :index="formatIndex"
        fixed="left"
        header-align="left"
        align="left"
        width="50"
        label="#"
      />
      <el-table-column
        prop="project"
        label="Project"
        width="180"
      ></el-table-column>
      <el-table-column prop="title" label="Title" min-width="300">
        <template slot-scope="scope">
          <a @click="gotoDetail(scope.row)" class="title-link">{{
            scope.row.title
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="recordDate" label="Record Date" width="180">
        <template slot-scope="scope">
          {{ formatTimestamp(scope.row.recordDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="issueDate" label="Issue Date" width="180">
        <template slot-scope="scope">
          {{ formatTimestamp(scope.row.issueDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="closeDate" label="Close Date" width="180">
        <template slot-scope="scope">
          {{ formatTimestamp(scope.row.closeDate) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="statusValue"
        label="Status"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="issuer"
        label="Issuer"
        width="180"
      ></el-table-column>
    </el-table>
    <!-- 分页部分：替换为Element UI原生完整分页组件 -->
    <div class="pagination-container">
      <el-pagination
        class="full-pagination"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        size="small"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'TenderList',
  data() {
    return {
      // 分页相关数据
      currentPage: 1,
      pageSize: 20,
      total: 0, // 改为从接口获取
      // 真实表格数据（替代原computed的模拟数据）
      tableData: [],
      // 加载状态
      loading: false,
    }
  },
  created() {
    // 组件初始化时加载第一页数据
    this.fetchTableData()
  },
  methods: {
    // 格式化表格序号
    formatIndex(index) {
      return index + 1 + (this.currentPage - 1) * this.pageSize
    },

    /**
     * 时间戳格式化函数
     * @param {Number} timestamp - 后端返回的时间戳（秒/毫秒都兼容）
     * @returns {String} 格式化后的日期：DD Month YYYY（如 24 March 2026）
     */
    formatTimestamp(timestamp) {
      if (!timestamp) return '-' // 空值处理
      // 兼容秒级时间戳（后端常见）和毫秒级时间戳
      const time =
        timestamp.toString().length === 10 ? timestamp * 1000 : timestamp

      const date = new Date(time)
      // 月份英文映射（匹配你的示例格式）
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ]
      const day = date.getDate()
      const month = months[date.getMonth()]
      const year = date.getFullYear()
      return `${day} ${month} ${year}`
    },

    /**
     * 核心函数：获取表格数据（调用后端接口）
     * 可直接调用，支持传参覆盖当前分页参数
     * @param {Number} page - 页码（可选，默认currentPage）
     * @param {Number} size - 每页条数（可选，默认pageSize）
     */
    async fetchTableData(page = this.currentPage, size = this.pageSize) {
      try {
        // 开启加载状态
        this.loading = true

        // 调用后端接口（替换为你的真实接口地址和参数）
        const response = await axios({
          url: `${this.$url.memo.url_render_list}`, // 你的真实接口地址
          method: 'get',
          params: {
            pageNum: page, // 页码
            pageSize: size, // 每页条数
            // 可添加其他查询参数，如：status: 'waiting for issuing'
          },
        })

        // 处理接口返回数据（根据后端返回格式调整）
        console.log(response)
        if (response.data.code === 200) {
          // 假设后端返回code=200为成功
          this.tableData = response.data.data.list || [] // 表格数据列表
          this.total = response.data.data.total || 0 // 总条数
          // 同步分页参数
          this.currentPage = page
          this.pageSize = size
        } else {
          // 接口返回异常提示
          this.$message.error(
            response.data.msg || 'Failed to fetch tender data',
          )
        }
      } catch (error) {
        // 网络异常/接口报错处理
        console.error('获取招标列表失败：', error)
        this.$message.error('Network error, please try again later')
        this.tableData = [] // 清空数据
        this.total = 0
      } finally {
        // 关闭加载状态
        this.loading = false
      }
    },
    gotoDetail(row) {
      console.log(row)
      this.$router.push(`/tender-detail?id=${row.recid}`)
    },

    // 切换分页页码（Element UI原生事件）
    handleCurrentChange(page) {
      this.currentPage = page
      // 调用接口获取对应页数据
      this.fetchTableData(page)
    },

    // 切换每页条数（Element UI原生事件）
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1 // 重置为第一页
      // 调用接口重新加载数据
      this.fetchTableData(1, size)
    },
  },
}
</script>

<style scoped>
.tender-list-container {
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
}
.page-title {
  font-size: 2.5rem;
  color: #1f2937;
  margin: 0 0 20px 0;
  font-weight: 600;
}
.title-link {
  color: #0d47a1;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
}
.title-link:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* 表格样式补充 */
::v-deep .el-table th {
  font-weight: 500;
}
::v-deep .el-table td {
  padding: 12px 0;
}

/* 原生分页组件样式优化 */
.pagination-container {
  margin-top: 20px;

  font-size: 13px;
  color: #333;
}
::v-deep .full-pagination {
  font-size: 13px;
}
/* 分页按钮样式统一 */
::v-deep .full-pagination .el-pager li {
  /* margin: 0 2px; */
  padding: 0 1px !important;
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  font-weight: 600;
}
::v-deep .full-pagination .el-pager li.active {
  /* background-color: #409eff; */
  color: #40b7ff;
  border-radius: 2px;
}
::v-deep .full-pagination .el-pagination__sizes .el-input__inner {
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  padding: 0 10px;
}
::v-deep .full-pagination .el-pagination__jump .el-input__inner {
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  width: 70px;
}
</style>
